import type { BillingApi } from '@env0/billing-service/api';
import { links } from 'constants/external-links';
import { EventNames, track } from 'utils/analytics.utils';

const planCards = ['free', 'pro', 'business'] as const;
type PlanCards = (typeof planCards)[number];
type PlansStatuses = Record<PlanCards, { disabled: boolean; isActive: boolean; endsAt?: Date }>;

const tierToActivePlan: Record<BillingApi.CustomerTier, PlanCards> = {
  basic: 'free',
  trial: 'pro',
  pro: 'pro',
  business: 'business',
  enterprise: 'business'
};

export const handleBillingCards = (billingInformation: BillingApi.BillingInfo) => {
  const isTrial = billingInformation.tier === 'trial';
  return {
    plansStatuses: getPlansStatuses(billingInformation.tier, billingInformation.currentPlanEndTime),
    isTrial,
    showMarketplaces: billingInformation.tier === 'basic' || isTrial
  };
};

const getPlansStatuses = (tier: BillingApi.CustomerTier, endsAt?: Date): PlansStatuses => {
  const activePlan = tierToActivePlan[tier];
  const activePlanIndex = planCards.indexOf(activePlan);
  return planCards.reduce((acc, plan, index) => {
    acc[plan] = {
      isActive: activePlan === plan,
      endsAt: activePlan === plan && endsAt ? endsAt : undefined,
      disabled: index < activePlanIndex
    };
    return acc;
  }, {} as PlansStatuses);
};

export const openContactUs = (event: EventNames) => {
  track(event);
  window.open(links.BILLING.CONTACT_US, '_blank');
};

export const upgradeToProPlan = async (
  getManageSubscriptionLink: () => Promise<BillingApi.ManageSubscriptionLink>,
  provider?: BillingApi.BillingProvider
) => {
  const shouldFetchManageSubscriptionLink = provider === 'stripe';
  let link: string;

  if (shouldFetchManageSubscriptionLink) {
    const { manageSubscriptionLink } = await getManageSubscriptionLink();
    link = manageSubscriptionLink;
  } else {
    link = provider === 'aws-marketplace' ? links.BILLING.AWS_MARKETPLACE : links.BILLING.AZURE_MARKET_PLACE;
  }

  track(EventNames.UPGRADE_TO_PRO_TIER_CLICK);

  window.open(link, '_blank');
};

export const openManageSubscription = async (
  getManageSubscriptionLink: () => Promise<BillingApi.ManageSubscriptionLink>,
  event: EventNames
) => {
  const { manageSubscriptionLink } = await getManageSubscriptionLink();

  track(event);

  window.open(manageSubscriptionLink, '_blank');
};
